import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import "./home-client-v21.css"
import "./NotFoundPage.css"

const translations = {
  fr: {
    pageNotFound: "Page introuvable",
    pageNotFoundDescription:
      "La page que vous recherchez n'existe pas ou a été déplacée.",
    backToHome: "Retour à l'accueil",
  },
  en: {
    pageNotFound: "Page not found",
    pageNotFoundDescription:
      "The page you are looking for does not exist or has been moved.",
    backToHome: "Back to home",
  },
  ar: {
    pageNotFound: "الصفحة غير موجودة",
    pageNotFoundDescription:
      "الصفحة التي تبحث عنها غير موجودة أو تم نقلها.",
    backToHome: "العودة إلى الصفحة الرئيسية",
  },
}

export default function NotFoundPage() {
  const navigate = useNavigate()
  const [currentLanguage, setCurrentLanguage] = useState("fr")

  useEffect(() => {
    const saved = localStorage.getItem("novotel-language")
    if (saved && translations[saved]) setCurrentLanguage(saved)
  }, [])

  const t = (key) =>
    translations[currentLanguage]?.[key] ?? translations.fr[key] ?? key

  const isRtl = currentLanguage === "ar"

  return (
    <div
      className={`novotel-v2-app novotel-v2-app-404 ${isRtl ? "rtl" : "ltr"}`}
      dir={isRtl ? "rtl" : "ltr"}
    >
      <div className="novotel-v2-hero">
        <div className="novotel-v2-hero-slideshow">
          <div
            className="novotel-v2-hero-slide active"
            style={{ backgroundImage: 'url("/images/hotel-lobby-v2.webp")' }}
          />
        </div>
        <div className="novotel-v2-hero-overlay">
          <div className="novotel-v2-hero-content novotel-v2-404-content">
            <div className="novotel-v2-404-card">
              <div className="novotel-v2-404-code" aria-hidden="true">404</div>
              <div className="novotel-v2-404-divider" aria-hidden="true" />
              <div className="novotel-v2-hero-logo novotel-v2-404-logo" aria-hidden="true">
                NOVOTEL
              </div>
              <h1 className="novotel-v2-404-message">{t("pageNotFound")}</h1>
              <p className="novotel-v2-404-sub">
                {t("pageNotFoundDescription")}
              </p>
              <button
                type="button"
                className="novotel-v2-404-btn"
                onClick={() => navigate("/home")}
              >
                <span className="novotel-v2-404-btn-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M19 12H5M12 19l-7-7 7-7" />
                  </svg>
                </span>
                {t("backToHome")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
